
import MediaCard from './MediaCard.vue'

export default {
  components: { MediaCard },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
